import type { BlockType } from '../../constants/blocks.ts';
import type { BlockPromptBuilder } from './types.ts';

export type {
  BlockPromptContext,
  BackMatterPromptContext,
  BlockPromptBuilder,
  BackMatterPromptBuilder,
} from './types.ts';
export { buildProgressionClause, buildExampleClause, buildCrossMonthClause } from './types.ts';
export { buildPersonalizationClause, buildLearningReasonTone } from './personalization-helpers.ts';

export { buildVocabularyGridPrompt } from './vocabulary-grid.ts';
export { buildGuidedConversationPrompt } from './guided-conversation.ts';
export { buildFillInTheBlankPrompt } from './fill-in-the-blank.ts';
export { buildReadingComprehensionPrompt } from './reading-comprehension.ts';
export { buildMatchingExercisePrompt } from './matching-exercise.ts';
export { buildScenarioPromptsPrompt } from './scenario-prompts.ts';
export { buildTranslationChallengePrompt } from './translation-challenge.ts';
export { buildConjugationSpotlightPrompt } from './conjugation-spotlight.ts';
export { buildGrammarExplanationPrompt } from './grammar-explanation.ts';

export { buildVerbGlossaryPrompt } from './verb-glossary.ts';
export { buildCulturalNotesPrompt } from './cultural-notes.ts';
export { buildWelcomePagePrompt } from './welcome-page.ts';
export type { WelcomePagePromptContext } from './welcome-page.ts';

// Import all builders for the lookup map
import { buildVocabularyGridPrompt } from './vocabulary-grid.ts';
import { buildGuidedConversationPrompt } from './guided-conversation.ts';
import { buildFillInTheBlankPrompt } from './fill-in-the-blank.ts';
import { buildReadingComprehensionPrompt } from './reading-comprehension.ts';
import { buildMatchingExercisePrompt } from './matching-exercise.ts';
import { buildScenarioPromptsPrompt } from './scenario-prompts.ts';
import { buildTranslationChallengePrompt } from './translation-challenge.ts';
import { buildConjugationSpotlightPrompt } from './conjugation-spotlight.ts';
import { buildGrammarExplanationPrompt } from './grammar-explanation.ts';

/**
 * Lookup map: given a block type, get the prompt builder function.
 * Used by the generation orchestrator to build prompts dynamically.
 */
export const BLOCK_PROMPT_BUILDERS: Record<BlockType, BlockPromptBuilder> = {
  vocabulary_grid: buildVocabularyGridPrompt,
  guided_conversation: buildGuidedConversationPrompt,
  fill_in_the_blank: buildFillInTheBlankPrompt,
  reading_comprehension: buildReadingComprehensionPrompt,
  matching_exercise: buildMatchingExercisePrompt,
  scenario_prompts: buildScenarioPromptsPrompt,
  translation_challenge: buildTranslationChallengePrompt,
  conjugation_spotlight: buildConjugationSpotlightPrompt,
  grammar_explanation: buildGrammarExplanationPrompt,
};
